export const FETCH_PIM_VENDOR_START = "FETCH_PIM_VENDOR_START";
export const FETCH_PIM_VENDOR_SUCCESS = "FETCH_PIM_VENDOR_SUCCESS";
export const FETCH_PIM_VENDOR_FAIL = "FETCH_PIM_VENDOR_FAIL";

export const CREATE_PIM_VENDOR_START = "CREATE_PIM_VENDOR_START";
export const CREATE_PIM_VENDOR_SUCCESS = "CREATE_PIM_VENDOR_SUCCESS";
export const CREATE_PIM_VENDOR_FAIL = "CREATE_PIM_VENDOR_FAIL";

export const SET_PIM_VENDOR_DATA_START = "SET_PIM_VENDOR_DATA_START";
export const SET_PIM_VENDOR_DATA_SUCCESS = "SET_PIM_VENDOR_DATA_SUCCESS";
export const SET_PIM_VENDOR_DATA_FAIL = "SET_PIM_VENDOR_DATA_FAIL";

export const RESET_PREFILLED_DATA = "RESET_PREFILLED_DATA";

export const FETCH_PIM_VENDOR_DROPDOWN_START = "FETCH_PIM_VENDOR_DROPDOWN_START";
export const FETCH_PIM_VENDOR_DROPDOWN_SUCCESS = "FETCH_PIM_VENDOR_DROPDOWN_SUCCESS";
export const FETCH_PIM_VENDOR_DROPDOWN_FAIL = "FETCH_PIM_VENDOR_DROPDOWN_FAIL";

export const SET_PIM_VENDOR_CURRENT_PAGE = "SET_PIM_VENDOR_CURRENT_PAGE";

export const SET_PIM_VENDOR_SEARCH_INPUT = "SET_PIM_VENDOR_SEARCH_INPUT";

export const SET_PIM_VENDOR_PAGE_SIZE = "SET_PIM_VENDOR_PAGE_SIZE";

export const SET_PIM_VENDOR_DROPDOWN_ID = "SET_PIM_VENDOR_DROPDOWN_ID";

export const RESET_PIM_VENDOR = "RESET_PIM_VENDOR";
